module.exports = __webpack_public_path__ + "img/baokuan.6313c8c8.png";